import { MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import localisation from "../../localisation";
import { useQueryCurrencies } from "../../services/use-currency-api";

export type CurrencySelectedCallback = (currencyCode: string) => void;

type CurrencySelectorProps = {
    selectedCurrencyCode: string;
    onSelected: CurrencySelectedCallback;
    required?: boolean;
    error?: boolean;
    onBlur?: () => void;
};

const CurrencySelector = (props: CurrencySelectorProps) => {
    const { currencySelector } = localisation;
    const { data } = useQueryCurrencies();
    return (
        <>
            {data ? (
                <TextField
                    id="currency-selector"
                    label={currencySelector.label}
                    value={props.selectedCurrencyCode}
                    select
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    error={props.error}
                    required={props.required}
                    onChange={(event) => props.onSelected(event.target.value)}
                    onBlur={() => props.onBlur?.()}
                >
                    {data.map((option) => (
                        <MenuItem key={option.currencyCode} value={option.currencyCode}>
                            {option.description}
                        </MenuItem>
                    ))}
                </TextField>
            ) : null}
        </>
    );
};

export default CurrencySelector;
